import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {ConfigAlertService} from '../../../service/staff/service-configalert';
import {ConfigAlert} from '../../../models/staff/configalert';
import {Sessioncommand} from '../../../global/sessioncommand';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {AlertType} from '../../../models/staff/alerttype';
import {AlertTypeService} from '../../../service/staff/service-alerttype';
@Component({
  templateUrl: './configalert.component.html'

})
export class ConfigAlertComponent implements OnInit, AfterViewInit {
  public language = language;
  public onClose: Subject<boolean>;
  public configList: ConfigAlert[] = [];
  constructor( public configAlertService: ConfigAlertService,
               public alertTypeService: AlertTypeService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public _bsModalRef: BsModalRef,
               public bsModalService: BsModalService
  ) {
  }
  ngAfterViewInit() {
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.alertTypeService.getAll().subscribe( data => {
      this.configAlertService.findAllByStaffId(Sessioncommand.staffId).subscribe( datax =>{
        for (let i = 0; i < data.length; i ++)
        {
          const index = datax.findIndex(x => x.typeId === data[i].id );
           const configAlert = new ConfigAlert();
                 configAlert.id = index !== -1 ? datax[index].id : 0;
                 configAlert.typeId = data[i].id;
                 configAlert.title = data[i].name;
                 configAlert.staffId = index !== -1 ? datax[index].staffId : Sessioncommand.staffId;
                 configAlert.soNgay = index !== -1 ? datax[index].soNgay : 2;
                 this.configList.push(configAlert);
        }
            });
    });

  }
  public edit()
  {

  }
  public actionConfig(): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.message_question_config,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
          for(let i = 0; i< this.configList.length; i++)
          {
            this.configAlertService.update(this.configList[i]).subscribe({
              next: (data) => {
              },
              error: error => {
                this.toastr.error(language.error, language.message);
              }
            });
          }
          this.toastr.success(language.message_save_config_success, language.message);
      }
    });
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

